import { Block, Button, LabelMedium, MonoLabelXSmall, ParagraphSmall, useStyletron, } from "@mezo-org/mezo-clay";
import React, { useCallback, useState } from "react";
import { useCopyToClipboard } from "usehooks-ts";
import { QRCodeSVG } from "qrcode.react";
import NestedViewLayout from "../NestedViewLayout";
import { getAddressExplorerUrl } from "../../../utils/address";
import { usePassportContext } from "../../../hooks/usePassportContext";
import useWalletAccount from "../../../hooks/useWalletAccount";
function Receive(props) {
    const { address } = props;
    const { environment } = usePassportContext();
    const blockExplorerUrl = getAddressExplorerUrl(address, "mezo", environment === "testnet");
    const [, theme] = useStyletron();
    const [, copy] = useCopyToClipboard();
    const [isCopiedMessageVisible, setIsCopiedMessageVisible] = useState(false);
    const handleCopyAddress = useCallback(() => {
        copy(address);
        setIsCopiedMessageVisible(true);
        setTimeout(() => {
            setIsCopiedMessageVisible(false);
        }, 2000);
    }, [copy, address]);
    const { networkFamily } = useWalletAccount();
    return (React.createElement(NestedViewLayout, null,
        React.createElement(LabelMedium, null, "Your Mezo Address"),
        React.createElement(ParagraphSmall, { marginTop: theme.sizing.scale300, marginBottom: theme.sizing.scale600, color: theme.colors.contentTertiary }, networkFamily === "bitcoin" ? (React.createElement(React.Fragment, null, "Mezo automatically created a smart account that's fully controlled by your connected Bitcoin wallet. Use this address to receive assets on Mezo.")) : (React.createElement(React.Fragment, null, "Your connected wallet address is your Mezo address. Use this address to receive assets on Mezo."))),
        React.createElement(Block, { as: QRCodeSVG, value: address, flex: 1, overrides: {
                Block: {
                    style: {
                        aspectRatio: 1,
                        width: "fit-content",
                        margin: "0 auto",
                    },
                },
            } }),
        React.createElement(MonoLabelXSmall, { marginTop: theme.sizing.scale800, marginBottom: theme.sizing.scale800, overrides: {
                Block: {
                    style: {
                        textAlign: "center",
                    },
                },
            } }, address),
        React.createElement(Button, { onClick: handleCopyAddress, overrides: {
                BaseButton: {
                    style: {
                        marginBottom: theme.sizing.scale400,
                    },
                },
            } }, isCopiedMessageVisible ? "Copied!" : "Copy Mezo Address"),
        React.createElement(Button, { kind: "secondary", "$as": "a", href: blockExplorerUrl, target: "_blank" }, "View Explorer")));
}
export default Receive;
//# sourceMappingURL=Receive.js.map